import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError, of } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { map, mergeMap, catchError, retry, delay } from 'rxjs/operators';
import { Gate } from '../models/gate';
import { Screen, ScreenPositionTypeList } from '../models/screen';

@Injectable({
	providedIn: 'root'
})

export class GateService {

	constructor(private http: HttpClient, private authService: AuthService) { }

	getStoreGates(storeGuid: string) {
		let gateApiUrl_inline: string = ConfigService.APP_API_ENDPOINT + "gate/getstore" + "?storeGuid=" + storeGuid;
        return from(this.authService.GetDefaultHeaders()).pipe(
            mergeMap(contentHeaders => { return this.http.get(gateApiUrl_inline, { headers: contentHeaders }) }),
            map((response:any) => { return response.objectdata }),
            catchError(error => {
                return this.handleError(error);
            })
        );
	}
	
	getStoreScreens(storeGuid: string) {
		let screeApiUrl_inline: string = ConfigService.APP_API_ENDPOINT + "screen/getstore" + "?storeGuid=" + storeGuid;
        return from(this.authService.GetDefaultHeaders()).pipe(
            mergeMap(contentHeaders => { return this.http.get(screeApiUrl_inline, { headers: contentHeaders }) }),
            map((response:any) => { return response.objectdata }),
            catchError(error => {
                return this.handleError(error)
            })
        );
    }

	editScreenBrightness(screen: Screen, brightnessDay: number, brightnessNight: number, autoBrightness: boolean) {
        var body = JSON.stringify({
            screenGuid: screen.screenGuid, name: screen.name, brightnessDay: brightnessDay, brightnessNight: brightnessNight, autoBrightness: autoBrightness, rotation: screen.rotation, position: screen.position.id
        });

        return from(this.authService.GetDefaultHeaders()).pipe(
            mergeMap(contentHeaders => { return this.http.put(ConfigService.APP_API_ENDPOINT + "screen", body, { headers: contentHeaders }) }),
            mergeMap((response:any) => { 
                if (response.returnCode < 0) { 
                    return throwError(response.errorMessage) 
                } else {
                    return of(response);
                }
            }),
            catchError(error => {
                console.log(error);
                return throwError(error);
            })
        );
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof ErrorEvent) {
		  // A client-side or network error occurred. Handle it accordingly.
		  console.error('An error occurred:', error.error.message);
		} else {
		  // The backend returned an unsuccessful response code.
		  // The response body may contain clues as to what went wrong,
		  console.error(
			`Backend returned code ${error.status}, ` +
			`body was: ${error.error}`);

			// return an observable with a user-facing error message
			return throwError('Unable to fetch Gates; Error code ' + error.status + ' (' + error.statusText + ')');
		}
		// return an observable with a user-facing error message
		return throwError(
		  'Unable to fetch Gates; please try again later.');
	};
}
